/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceUnitCategoryDto
 */
export interface PriceUnitCategoryDto {
    /**
     * 
     * @type {number}
     * @memberof PriceUnitCategoryDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PriceUnitCategoryDto
     */
    name: string | null;
}

/**
 * Check if a given object implements the PriceUnitCategoryDto interface.
 */
export function instanceOfPriceUnitCategoryDto(value: object): value is PriceUnitCategoryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PriceUnitCategoryDtoFromJSON(json: any): PriceUnitCategoryDto {
    return PriceUnitCategoryDtoFromJSONTyped(json, false);
}

export function PriceUnitCategoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceUnitCategoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function PriceUnitCategoryDtoToJSON(json: any): PriceUnitCategoryDto {
    return PriceUnitCategoryDtoToJSONTyped(json, false);
}

export function PriceUnitCategoryDtoToJSONTyped(value?: PriceUnitCategoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

